import React, { useState, useRef, useEffect } from "react";


import { RiSkipBackLine, RiSkipForwardLine, RiReplay30Line } from "react-icons/ri";
import { PiPauseLight, PiPlayLight } from "react-icons/pi";
import { TbMultiplier1X } from "react-icons/tb";
import { CgPlayList, CgMathPlus } from 'react-icons/cg';
import { HiMiniSpeakerWave } from "react-icons/hi2";
import { IoVolumeMuteSharp } from "react-icons/io5";

import SongData from './Songs';

function PlayAudio() {
    const [playsong, setPlaysong] = useState(false);
    const [currTime, setCurrTime] = useState({ min: "", sec: "" });
    const [duration, setDuration] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [volume, setVolume] = useState(1); 
    // const [showSongList, setShowSongList] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0)
    const [speed , setSpeed] = useState(1.0)
    const playRef = useRef();
    
    const [clickCount, setClickCount] = useState(0);

    const play = () => {
        if (playsong === false) {
            setPlaysong(true);
            playRef.current.play();
        } else {
            setPlaysong(false);
            playRef.current.pause();
        }
    };

    const handleTimeUpdate = () => {
        setCurrTime({
            min: Math.floor(playRef.current.currentTime / 60),
            sec: Math.floor(playRef.current.currentTime % 60)
        });
        setDuration(playRef.current.duration);
        setSeconds(playRef.current.currentTime);
    };

    const handleTimeBack = (timeInSeconds) => {
        playRef.current.currentTime -= timeInSeconds;
    };

    const handleTimeForword = (timeInSeconds) => {
        playRef.current.currentTime += timeInSeconds;
    };

    const handleVolume = () => {
        const newVolume = volume === 1 ? 0 : 1;
        setVolume(newVolume);
        playRef.current.volume = newVolume;
    };
    const handleSkipForward = () => {
        const nextIndex = currentIndex + 1;
        if (nextIndex < SongData.length) {
            setCurrentIndex(nextIndex);
        }
    };
   
    const handleSpeed = () => {
        const newClickCount = clickCount + 1;
        if (newClickCount % 2 === 0) {
            setSpeed(1.0);
        } else {
            const newSpeed = speed * 1.5;
            setSpeed(newSpeed);
        }
        setClickCount(newClickCount);
        if (playRef.current) {
            playRef.current.playbackRate = speed;
        }
    }
    
    useEffect(() => {
        console.log("SongData", SongData);
    }, []);
    
    useEffect(() => {
        
        playRef.current.addEventListener('timeupdate', handleTimeUpdate);
      
    },[]);

    useEffect(() => {
        playRef.current.load(); 
        if (playsong) {
            playRef.current.play();
        }
    }, [currentIndex]);

    useEffect(() => {
        const updateDuration = () => {
            setDuration(playRef.current.duration);
        };
        playRef.current.addEventListener('loadedmetadata', updateDuration);
       
    }, []);

    return (

        <div className="bg-back-image w-full bg-cover bg-center h-dvh"  >
            <div className="flex flex-col justify-center items-center py-28 px-2 text-white gap-5">
                <div className="w-60 rounded-xl ">
                    <img src={SongData[currentIndex]?.imageUrl} alt="songs poster" className="rounded-xl" />
                </div>
                <div className="">
                    <div className="">
                        <h4>{SongData[currentIndex]?.title}</h4>
                        <p className="text-gray  flex flex-wrap">{SongData[currentIndex]?.description}</p>
                    </div>
                    <div className="flex items-center">
                        <span>{currTime.min}:{currTime.sec}</span>
                        <input
                            type="range"
                            min="0"
                            max={duration}
                            value={seconds}
                            className="timeline max-sm:w-40"
                            style={{width:'20rem'}}
                            onChange={(e) => {
                                playRef.current.currentTime = e.target.value;
                                setSeconds(e.target.value);
                            }}
                        />
                        <span>{Math.floor(duration / 60)}:{Math.floor(duration % 60)}</span>
                        <audio ref={playRef}  autoPlay src={SongData[currentIndex]?.src} className="" />
                    </div>
                </div>

                <div className="">
                    <div className="flex gap-6 " >
                        <RiSkipBackLine className="w-4 h-4 cursor-pointer"  onClick={() => setCurrentIndex(currentIndex - 1)} />
                        <RiReplay30Line  className="w-4 h-4  cursor-pointer" onClick={() => handleTimeBack(30)} />
                        <button onClick={play}>
                            {playsong ? <PiPauseLight  className="w-4 h-4  cursor-pointer" /> : <PiPlayLight  className="w-4 h-4 " />}
                        </button>
                        <RiReplay30Line  className="w-4 h-4 cursor-pointer" onClick={() => handleTimeForword(30)} />
                        <RiSkipForwardLine className="w-4 h-4  cursor-pointer" onClick={handleSkipForward} />
                    </div>
                    <div className="flex gap-3 absolute -mt-4 ml-80 max-md:hidden ">
                        <TbMultiplier1X  className="w-4 h-4 cursor-pointer"  onClick={handleSpeed}/>
                        {volume === 1 ? (
                            <HiMiniSpeakerWave  className="w-4 h-4 cursor-pointer" onClick={handleVolume} />
                        ) : (
                            <IoVolumeMuteSharp   className="w-4 h-4 cursor-pointer" onClick={handleVolume} />
                        )}
                        <CgMathPlus  className="w-4 h-4  cursor-pointer" />
                        <div>
                            <CgPlayList  className="w-4 h-4  cursor-pointer"  />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default PlayAudio;
